import React from "react";
import { Link } from "react-router-dom";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import BreadCrumbs from "../../../layout/BreadCrumbs";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";

const Configure = () => {
  return (
    <div className="settings">
      <BreadCrumbs
        data={[
          { name: "Settings", link: "/manage" },
          { name: "Configure", link: "/manage/config" },
        ]}
      />
      {/* <h3 className="mb-2 uppercase grey">Configure Firm</h3> */}
      <div className="grid-card2">
        <Link to="/admin/config/company-info" className="card2">
          <div className="card-left">
            <div className="icon">
              <AppRegistrationIcon />
            </div>
            <p>Company Info</p>
          </div>
          <div className="card-right">
            <ChevronRightRoundedIcon />
          </div>
        </Link>

        <Link to="/admin/config/company-theme" className="card2">
          <div className="card-left">
            <div className="icon">
              <ColorLensIcon />
            </div>
            <p>Application Theme</p>
          </div>
          <div className="card-right">
            <ChevronRightRoundedIcon />
          </div>
        </Link>

        <Link to="/admin/config/accounts" className="card2">
          <div className="card-left">
            <div className="icon">
              <CreditCardRoundedIcon />
            </div>
            <p>Accounts</p>
          </div>
          <div className="card-right">
            <ChevronRightRoundedIcon />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Configure;
